<div *ngIf="!widgetsLoaded" fxLayout="row" fxLayoutAlign="space-between center" class="widget-bar">
    <div fxFill fxLayout="row" fxLayoutAlign="space-around center">
        <forge-skeleton class="widget placeholder"></forge-skeleton>
        <forge-skeleton class="widget placeholder"></forge-skeleton>
        <forge-skeleton class="widget placeholder"></forge-skeleton>
        <forge-skeleton class="widget placeholder"></forge-skeleton>
    </div>
</div>

<div *ngIf="widgetsLoaded" fxFill fxLayout="row" fxLayoutAlign="space-between center" class="widget-bar">
    <forge-icon-button *ngIf="hasPreviousPage" (click)="goToPreviousPage()" aria-label="Go to previous widget page">
        <forge-tooltip>Previous</forge-tooltip>
    <forge-icon name="arrow_back"></forge-icon>
        </forge-icon-button>

    <forge-view-switcher #viewSwitcher animation-type="slide" [index]="page" style="width: 100%;">
        <forge-view *ngFor="let page of pages">
            <div fxFill fxLayout="row" fxLayoutAlign="space-around center">
                <div *ngFor="let widget of page">
                    <widget fxFill [widget]="widget"></widget>
                </div>
            </div>
        </forge-view>
    </forge-view-switcher>

    <forge-icon-button *ngIf="hasNextPage" (click)="goToNextPage()" aria-label="Go to next widget page">
        <forge-tooltip>Next</forge-tooltip>
    <forge-icon name="arrow_forward"></forge-icon>
        </forge-icon-button>
</div>